import { Component, Input } from '@angular/core';
import { MembershipOwnerComponent } from "../../../services/membership/membership-owner/membership-owner.component";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { TranslateModule } from '@ngx-translate/core';
import { AddOwnerPartnerComponent } from "../../../services/membership/add-owner-partner/add-owner-partner.component";


@Component({
  selector: 'app-membership-owners',
  imports: [MembershipOwnerComponent, TranslateModule, AddOwnerPartnerComponent],
  templateUrl: './membership-owners.component.html',
  styleUrl: './membership-owners.component.scss'
})
export class MembershipOwnersComponent {
  @Input() owners: any[] = [];
  @Input() documents: any;
  isOwnerModalOpen: boolean = false;
  selectedOwner: any = "";
  // This method is used to initialize the class instance
  constructor() {
  }
  // This method is used to view owner detail using owner
  viewOwnerDetail(owner: any) {
    this.selectedOwner = owner.data;
    this.isOwnerModalOpen = true;
  }
  // This method is used to handle owner submit event using values
  onOwnerSubmit(values: any) {

  }
}
